import { isDefined } from "@clipboard-health/util-ts";
import { Stack } from "@mui/material";
import { useSession } from "@src/appV2/Auth/api/useSession";
import { Text } from "@src/appV2/redesign/components/Text";
import { useDisplayTime } from "@src/appV2/redesign/components/LocalTime/useDisplayTime";

import { getCityFromTimezone } from "./timezone";

/**
 * Title-style version of the workplace context for use as a drawer/sheet
 * header. Renders the workplace name large with a muted local-time subtitle.
 * Returns null for sessions without a workplace profile.
 */
export function WorkplaceContextTitle() {
  const { profile, tz } = useSession();
  const workplaceName = profile?.name;
  const localTime = useDisplayTime({ timeZone: tz });

  if (!isDefined(workplaceName)) {
    return null;
  }

  const city = isDefined(tz) ? getCityFromTimezone(tz) : undefined;
  const showSubtitle = isDefined(localTime) && isDefined(city);

  return (
    <Stack direction="column" sx={{ minWidth: 0, lineHeight: 1.2 }}>
      <Text
        variant="h6"
        semibold
        noWrap
        sx={(theme) => ({ color: theme.palette.navbar?.userName })}
      >
        {workplaceName}
      </Text>
      {showSubtitle && (
        <Text
          variant="caption"
          noWrap
          sx={(theme) => ({
            color: theme.palette.navbar?.itemContent,
            letterSpacing: "0.02em",
          })}
        >
          {localTime} · {city}
        </Text>
      )}
    </Stack>
  );
}
